import React from "react";
import { Link } from "react-router-dom";

const TermsConditionsPage = () => {
  return (
    <div className="page-shell internal-page">
      <section className="page-hero">
        <p className="section-kicker">Terms & Conditions</p>
        <h1>Terms for using this campaign website and communications.</h1>
        <p>Effective date: June 7, 2026</p>
      </section>

      <section className="content-panel prose-panel">
        <h2>Website use</h2>
        <p>
          This website is provided by the Brian Hodgers Campaign to share campaign information, accept
          inquiries, and connect with voters and supporters. By using this website, you agree to use it
          only for lawful purposes and in a way that does not interfere with campaign operations or the
          availability of the site.
        </p>

        <h2>Campaign communications</h2>
        <p>
          You agree to receive informational messages, account notifications, account updates, or
          donation request messages from the Brian Hodgers Campaign when you provide consent through a
          campaign form or other opt-in method. Message frequency varies. Message and data rates may
          apply. For help, email us at{" "}
          <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a>. You can opt out at
          any time by replying STOP.
        </p>

        <h2>No sale of information</h2>
        <p>
          The campaign does not sell the information it receives. Mobile opt-in information and consent
          records are not sold, rented, or shared with third parties for marketing or promotional
          purposes.
        </p>

        <h2>Third-party services</h2>
        <p>
          The campaign may use third-party providers for services such as donation processing, website
          hosting, email delivery, texting, analytics, or compliance support. Those providers may process
          information only as needed to provide services to the campaign or comply with legal
          obligations.
        </p>

        <h2>Privacy</h2>
        <p>
          For more information about how the campaign handles personal information, please review the{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent to{" "}
          <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a> or by phone at{" "}
          <a href="tel:3212094645">(321) 209-4645</a>.
        </p>
      </section>
    </div>
  );
};

export default TermsConditionsPage;
